import { createActionGroup, emptyProps, props } from '@ngrx/store';

import type { ProductTreeActionsItem } from 'src/app/core/models/productTreeActions.model';
import type { Entity } from '../../../core/models/entity.model';
import { Position } from 'src/app/core/models/position.model';

interface UpdateProjectStartParams {
  entityId: string;
  propertyKey: string;
  newValue: unknown;
  measurementUnit?: string;
  /**
   * If set to true, this will force the current project to be reloaded after the update is complete.
   */
  updateFullProject?: boolean;
}

interface UpdateProjectEntitiesParams {
  entityIds: string[];
  propertyKey: string;
  newValue: unknown;
  measurementUnit?: string;
}

export const ProjectDataActions = createActionGroup({
  source: 'Project data actions',
  events: {
    create_project_start: emptyProps(),
    create_project_success: props<{ createdId: string }>(),
    create_project_fail: props<{ error: any }>(),

    update_project_start: props<UpdateProjectStartParams>(),
    update_project_success: props<{
      updatedEntities: Entity[];
    }>(),
    update_project_fail: props<{ error: any }>(),

    update_project_entities_start: props<UpdateProjectEntitiesParams>(),

    update_hood_line_positions: props<{ entityId: string; position: Position }>(),

    get_project_start: props<{ id: string }>(),
    refresh_project: emptyProps(),
    get_project_success: props<{
      entities: Entity[];
    }>(),
    get_project_fail: props<{ error: any }>(),

    update_project_actions: props<{ projectActions: ProductTreeActionsItem[] }>(),

    export_xml_start: emptyProps(),
    export_xml_data_request: emptyProps(),
    export_xml_success: emptyProps(),
    export_xml_fail: props<{ error: any }>(),

    export_magicad_start: emptyProps(),
    export_magicad_data_request: emptyProps(),
    export_magicad_success: emptyProps(),
    export_magicad_fail: props<{ error: any }>(),

    get_report_start: props<{ reportType: string; extension: string }>(),
    get_report_data_request: props<{ reportType: string; extension: string }>(),
    get_report_success: emptyProps(),
    get_report_fail: props<{ error: any }>(),

    export_alldocuments_start: emptyProps(),
    export_alldocuments_data_request: emptyProps(),
    export_alldocuments_success: emptyProps(),
    export_alldocuments_fail: props<{ error: any }>(),

    // Create any entity in the product tree, except project (= except root level)
    create_entity_start: props<{ projectId: string; entityId: string; productTypeId: string; productName: string; defaultValues: any[] }>(),
    create_entity_success: props<{ projectId: string; createdId: string }>(),
    create_entity_fail: props<{ error: any }>(),

    reset_latest_created_id: emptyProps(),

    // Copy any entity in the product tree, except project
    copy_entity_start: props<{ entityId: string; parentId: string }>(),
    copy_entity_success: props<{ copiedId: string; parentId: string }>(),
    copy_entity_fail: props<{ error: any }>(),

    reset_latest_copied_id: emptyProps(),

    // Delete any entity in the product tree, except project
    delete_entity_start: props<{ entityIdList: string[] }>(),
    delete_entity_success: props<{ deletedIdList: string[] }>(),
    delete_entity_fail: props<{ error: any }>(),

    reset_latest_deleted_id: emptyProps(),

    throw_error: props<{ error: any }>(),

    initialize_action: emptyProps(),
    reset_initialize_action: emptyProps(),

    // export project to pyramid
    export_project_to_pyramid_start: emptyProps(),
    export_project_to_pyramid_request: emptyProps(),
    export_project_to_pyramid_success: emptyProps(),
    export_project_to_pyramid_fail: props<{ error: any }>(),

    // redirect to product page after generate hood
    redirect_to_product: props<{ projectId: string; entityId: string }>(),

    set_last_selected_hood_id: props<{ id: string }>(),
    set_last_selected_module_id: props<{ id: string }>(),
    set_last_selected_entity_id: props<{ id: string }>(),

    set_project_loaded: props<{ loaded: boolean }>(),

    set_hood_line_entities: props<{ entities: Entity[] }>()
  }
});
